import { render, staticRenderFns } from "./PadIndex.vue?vue&type=template&id=88f9ce74"
import script from "./PadIndex.vue?vue&type=script&lang=js"
export * from "./PadIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports